export const navigationName = {
  "/board/dashboard": "홈/대시보드",
  "/board/myPageUser": "홈/마이페이지",
  "/board/myPageAdmin": "홈/마이페이지",
  "/board/campaign": "홈/광고 관리/캠페인생성",
  "/board/campaignLookOver": "홈/광고 관리/캠페인 및 소재 관리/캠페인 검토",
  "/board/campaignTwo": "홈/광고 관리/캠페인 및 소재 관리/예산 및 입찰 설정",
  "/board/campaignThree": "홈/광고 관리/캠페인 및 소재 관리/광고그룹 설정",
  "/board/campaignFour": "홈/광고 관리/캠페인 및 소재 관리/소재 설정",
  "/board/createCreative": "홈/광고 관리/크리에이티브 생성",
  "/board/bannerCreative": "홈/광고 관리/배너 크리에이터",
  "/board/audioCreative": "홈/광고 관리/오디오 크리에이터",
  "/board/manageCreative": "홈/광고 관리/캠페인 및 소재 관리",
  "/board/manageCreativeDetail": "홈/광고 관리/캠페인 및 소재 관리 상세",
  "/board/reports": "홈/보고서/보고서 생성",
  "/board/reportsAdver": "홈/보고서/광고주별 보고서",
  "/board/reportsCampaign": "홈/보고서/캠페인별 보고서",
  "/board/reportsPeriod": "홈/보고서/일자별 보고서",
  "/board/reportsPeriodHour": "홈/보고서/시간대별 보고서",
  "/board/customReports": "홈/보고서/커스텀 보고서",
  "/board/notice": "홈/고객센터/공지사항",
  "/board/noticeDetail": "홈/고객센터/공지사항",
  "/board/inquiry": "홈/고객센터/1:1문의",
  "/board/inquiryDetail": "홈/고객센터/1:1문의",
  "/board/platform": "홈/플랫폼 관리/사용자 관리",
  "/board/platformAdmin": "홈/플랫폼 관리/관리자 관리",
  "/board/platformAdminDetail": "홈/플랫폼 관리/관리자 생성",
  "/board/platformDetail": "홈/플랫폼 관리/사용자 관리",
  "/board/platformTerm": "홈/플랫폼 관리/약관 관리",
  "/board/platformTermDetail": "홈/플랫폼 관리/약관 관리 상세",
  "/board/categoryManage": "홈/플랫폼 관리/광고주 카테고리 관리",
  "/board/productManage": "홈/플랫폼 관리/상품 수집 관리",
  "/board/conversionManage": "홈/플랫폼 관리/전환 관리",
  "/board/historyCampaignManage": "홈/플랫폼 관리/캠페인 이력 관리",
  "/board/historyPriceManage": "홈/플랫폼 관리/이벤트 단가 이력 관리",
  "/board/historyEventManage": "홈/플랫폼 관리/이벤트 예산 이력 관리",
  "/board/historyTimeManage": "홈/플랫폼 관리/시간별 예산 이력 관리",
  "/board/historyCampaignDetail": "홈/플랫폼 관리/캠페인 이력 상세",
  "/board/historyPriceDetail": "홈/플랫폼 관리/이벤트 단가 이력 상세",
  "/board/historyEventDetail": "홈/플랫폼 관리/이벤트 예산 이력 상세",
  "/board/historyTimeDetail": "홈/플랫폼 관리/시간별 예산 이력 상세",
  "/board/paymentManageUser": "홈/결제",
  "/board/paymentManage": "홈/플랫폼 관리/결제 관리",
  "/board/advertisingPayments": "홈/플랫폼 관리/포인트 관리",
  //"/board/settings": "홈/설정/타겟팅 단가 관리",
  "/board/settings": "홈/설정/시간별 예산 관리",
  "/board/settingsDetail": "홈/설정/타겟팅 단가 상세 관리",
  "/board/budgetEvent": "홈/설정/타겟팅 예산 관리",
  "/board/budgetEventDetail": "홈/설정/타겟팅 예산 상세 관리",
  "/board/budgetTime": "홈/설정/시간별 예산 관리",
  "/board/budgetTimeList": "홈/설정/시간별 예산 관리/시간별 예산 리스트",
  "/board/budgetTimeDetail": "홈/설정/시간별 예산 관리/시간별 예산 리스트/시간별 예산 그룹 설정",
}
export const dataTotalInfo = {
  totalCount:1,
  currentCount:1,
  totalPages:1,
  currentPage:1
}
